import Vue from 'vue'
let bus = new Vue();
let showEvent = '@chooseFriend';
let currComponentId = "";
export default {
  /**
   * 监听显示
   * @type {Function}
   */
  onShow: (function () {
    return function (handler) {
      bus.$on(showEvent, handler)
    }
  })(),
  /**
   * 监听回调
   */
  onCallback: (function () {
    return function (componentId, handler) {
      bus.$on(componentId, handler)
    }
  })(),
  /**
   * 显示
   * @param id 占用组件id
   * @param domRect 显示参照物domRect
   * @param selected Array 已选择的好友
   * @param limit 勾选数量限制
   */
  show: function(id, domRect, selected = [], limit = 50) {
    currComponentId = id;
    bus.$emit(showEvent, domRect, selected, limit)
  },
  /**
   * 回调
   * @param arr 选择的好友
   */
  callback: function (arr) {
    bus.$emit(currComponentId, arr)
  }
};



// WEBPACK FOOTER //
// ./src/js/bus/chooseFriendBus.js